var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgStateSyncingFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.7 110.3C88.1 110.3 110.4 88 110.4 60.6C110.4 33.2 88.1 10.9 60.7 10.9C33.3 10.9 11 33.2 11 60.6C11 88.1 33.3 110.3 60.7 110.3Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28.6C19.9 28.6 20.7001 27.8 20.7001 26.9C20.7001 26 19.9 25.2 19 25.2C18.1 25.2 17.3 26 17.3 26.9C17.3 27.8 18.1 28.6 19 28.6Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 92.5C14.1001 92.5 14.8001 91.8 14.8001 90.9C14.8001 90 14.1001 89.3 13.2001 89.3C12.3001 89.3 11.6001 90 11.6001 90.9C11.6001 91.8 12.3001 92.5 13.2001 92.5Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8 114.3C91.7 114.3 92.4 113.6 92.4 112.7C92.4 111.8 91.7 111.1 90.8 111.1C89.9 111.1 89.2 111.8 89.2 112.7C89.2 113.6 89.9 114.3 90.8 114.3Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61 121C94.1 121 121 94.1 121 61C121 27.9 94.1 1 61 1C27.9 1 1 27.9 1 61C1 94.1 27.9 121 61 121Z",
    stroke: "#EAEEF9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 70.3H69.9C72.4 70.3 74.4 72.3 74.4 74.8V97.3C74.4 99.8 72.4 101.8 69.9 101.8H58V110.7H56L49.0999 101.8H16.7C14.2 101.8 12.2 99.8 12.2 97.3V74.8C12.3 72.4 14.3 70.3 16.7 70.3Z",
    fill: "#3B0D80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4 21H7.19995C4.69995 21 2.69995 23 2.69995 25.5V48C2.69995 50.5 4.69995 52.5 7.19995 52.5H19.1L17.4 61.4H19.1L28 52.5H60.5C63 52.5 65 50.5 65 48V25.5C64.9 23 62.9 21 60.4 21Z",
    fill: "#3B0D80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H5.5C3 21 1 23 1 25.5V48C1 50.5 3 52.5 5.5 52.5H17.4V61.4L26.3 52.5H58.7C61.2 52.5 63.2 50.5 63.2 48V25.5C63.2 23 61.2 21 58.7 21H22.8",
    fill: "#F7EFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 21H15.7",
    stroke: "#182052",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52.5H58.7H60.5C63 52.5 65 50.5 65 48V25.5C64.9 23 62.9 21 60.4 21H58.7H19",
    stroke: "#182052",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 21H5.5C3 21 1 23 1 25.5V48C1 50.5 3 52.5 5.5 52.5H7.2H17.4V61.4H19.1L25.3 55.2",
    stroke: "#182052",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54 31H8V35H54V31Z",
    fill: "#E2CCFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.3 38.5H8.30005V42.3H37.3V38.5Z",
    fill: "#E2CCFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4 74.8V97.3C72.4 99.8 70.4 101.8 67.9 101.8H56V110.7L47.0999 101.8H14.7C12.2 101.8 10.2 99.8 10.2 97.3V74.8C10.2 72.3 12.2 70.3 14.7 70.3H67.9C70.4 70.3 72.4 72.4 72.4 74.8Z",
    fill: "#F7EFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0999 101.8L56 110.7H58V101.8H67.9H69.9C72.4 101.8 74.4 99.8 74.4 97.3V74.8C74.4 72.3 72.4 70.3 69.9 70.3H67.9H16.7H14.7C12.2 70.3 10.2 72.3 10.2 74.8V97.3C10.2 99.8 12.2 101.8 14.7 101.8H16.7H41.7",
    stroke: "#182052",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M72.4001 74.8V79.1H63.3C60.8 79.1 58.8 77.1 58.8 74.6V70.2H67.9001C70.4001 70.3 72.4001 72.4 72.4001 74.8Z",
    fill: "#3B0D80"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17 84H65V80H17V84Z",
    fill: "#E2CCFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28 92H65V88H28V92Z",
    fill: "#E2CCFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3 42.4H116.5C119 42.4 121 44.4 121 46.9V69.4C121 71.9 119 73.9 116.5 73.9H104.6V82.8H102.9L95.8001 73.9H63.3C60.8 73.9 58.8 71.9 58.8 69.4V46.9C58.8 44.4 60.9 42.4 63.3 42.4Z",
    fill: "#CAD1E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6999 42.4H114.9C117.4 42.4 119.4 44.4 119.4 46.9V69.4C119.4 71.9 117.4 73.9 114.9 73.9H103V82.8L94.0999 73.9H61.6999C59.1999 73.9 57.1999 71.9 57.1999 69.4V46.9C57.0999 44.4 59.0999 42.4 61.6999 42.4Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6667 63.6666H114.333V65.3333H97.6667V63.6666ZM99.3334 57H101V62.8333H99.3334V57ZM103.5 57H105.167V62.8333H103.5V57ZM106.833 57H108.5V62.8333H106.833V57ZM111 57H112.667V62.8333H111V57ZM97.6667 52.8333L106 48.6666L114.333 52.8333V56.1666H97.6667V52.8333ZM106 53.6666C106.221 53.6666 106.433 53.5788 106.589 53.4225C106.746 53.2663 106.833 53.0543 106.833 52.8333C106.833 52.6123 106.746 52.4003 106.589 52.244C106.433 52.0878 106.221 52 106 52C105.779 52 105.567 52.0878 105.411 52.244C105.255 52.4003 105.167 52.6123 105.167 52.8333C105.167 53.0543 105.255 53.2663 105.411 53.4225C105.567 53.5788 105.779 53.6666 106 53.6666Z",
    fill: "#DE350B"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.6 73.9H114.9H116.5C119 73.9 121 71.9 121 69.4V46.9C121 44.4 119 42.4 116.5 42.4H114.9H63.2999H61.6999C59.0999 42.4 57.0999 44.4 57.1999 46.9",
    stroke: "#182052",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2 52.5V69.4C57.2 71.9 59.2 73.9 61.7 73.9H63.2999H94.0999L102.5 82.3L102.9 82.8H104.6V77.3",
    stroke: "#182052",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1001 55.9H93.7001V52.1H66.1001V55.9Z",
    fill: "#DE350B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75 64H94V60H75V64Z",
    fill: "#DE350B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(96 47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStateSyncingFailed);
export default __webpack_public_path__ + "static/media/img_state_syncing_failed.e245f01945373991f8d688d25f744c6b.svg";
export { ForwardRef as ReactComponent };